import React from 'react'
import yup from 'yup'
import Form from 'react-formal'
import PasswordImage from '../../../img/icons/general-icons/password_icon.png'

var resetSchema = yup.object({
  npassword: yup.string().matches(/^.{6,}$/, 'La contraseña debe tener al menos 6 caracteres').required('Ingrese su contraseña'),
  cpassword: yup.string().required('Confirme su contraseña')
})

export default class ResetForm extends React.Component {
  constructor (props) {
    super(props)
    this.state = ({ model: {} })
  }

  resetPassword (e) {
    e.preventDefault()
    let npassword = this.state.model.npassword
    let cpassword = this.state.model.cpassword
    this.props.reset(npassword, cpassword)
  }

  render () {
    return (
      <Form id='resetForm' className='form' schema={resetSchema} value={this.state.model} onChange={model => this.setState({ model })}>
        <div className='form-field-container'>
          <img className='form-field-image' src={PasswordImage} />
          <Form.Field name='npassword' id='npassword' ref='npassword' type='password' className='form-field-input' placeholder='Contraseña' />
          <Form.Message className='message' for='npassword'/>
        </div>
        <div className='form-field-container'>
          <img className='form-field-image' src={PasswordImage} />
          <Form.Field name='cpassword' id='cpassword' ref='cpassword' type='password' className='form-field-input' placeholder='Confirmar contraseña' />
          <Form.Message className='message' for='cpassword'/>
        </div>
        <div className='form-submit-btn-container'>
          <Form.Button id='savePassword' className='form-submit-button' type='submit' onClick={this.resetPassword.bind(this)}>Guardar</Form.Button>
        </div>
      </Form>
    )
  }
}

/* Validate props */
ResetForm.propTypes = {
  reset: React.PropTypes.func
}



// WEBPACK FOOTER //
// ./src/components/Account/Reset/ResetForm.js